import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export const actionTypes = {
  Logout: '[Logout] Action',
  SetToken: '[SetToken] Action'
}

const initialAuthState = {
  authToken: undefined
}

export const reducer = persistReducer(
  {
    storage,
    key: 'demo1-auth',
    whitelist: ['usuario', 'authToken']
  },
  (state = initialAuthState, action) => {
    switch (action.type) {
      case actionTypes.Logout: {
        window.localStorage.removeItem('token')
        return initialAuthState
      }

      case actionTypes.SetToken: {
        const { authToken } = action.payload
        window.localStorage.setItem('token', authToken)

        return {
          authToken
        }
      }

      default:
        return state
    }
  }
)

export const actions = {
  setToken: authToken => ({ type: actionTypes.SetToken, payload: { authToken } }),
  logout: () => ({ type: actionTypes.Logout })
}
